import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { User } from './user';
import { DataService } from '../data.service';
import { AuthorizationService } from '../authorization.service';
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  redirectUrl: string;
  
  get currentUser(): User{
    if (!isPlatformBrowser(this.platformId))
      return null;
    let _currentUser=JSON.parse(sessionStorage.getItem('currentUser'));
    return _currentUser;
  }

  set currentUser(value){
    if (isPlatformBrowser(this.platformId))
      sessionStorage.setItem('currentUser',JSON.stringify(value));
  }
  
  get isLoggedIn():boolean {
    return !!this.currentUser;
  } 

  get isCoordinator(): boolean {
    if (!this.currentUser)
      return false;
    return this.currentUser['permLevel']==2;
  }

  get isBlncAdmin(): boolean {
    if (!this.currentUser)
      return false;
    return this.currentUser['permLevel']==3;
  }

  get isLeadAdmin(): boolean {
    if (!this.currentUser)
      return false;
    return this.currentUser['permLevel']==4;
  }

  constructor(private dataService: DataService, public authorizationService: AuthorizationService,
            private router: Router, private idle: Idle, @Inject(PLATFORM_ID) private platformId: Object) {  }

  logout(): void {
    this.idle.stop();  
    this.dataService.clearCache();
    sessionStorage.removeItem("currentUser");
    this.redirectUrl='/';
    this.authorizationService.signOut();
  }

  login(userName: string, password: string): void {
 //   if (!isPlatformBrowser(this.platformId))
 //     return;
 //   sessionStorage.removeItem("currentUser"); // NTS - 
    this.dataService.login(userName, password).subscribe((data: User)=>{
      if  (data['error']){
        console.log(data['error']);
        alert(data['error']);
        this.router.navigate(['/']);
        return;
      }
      this.idle.watch();
      let currentUser=data;
      console.log(data);
      sessionStorage.setItem("currentUser", JSON.stringify(currentUser));   
      this.dataService.clearCache();
//      console.log(this.redirectUrl);
      if (currentUser.permLevel==2 && currentUser.updatedDate< this.getFilterDate()) {
        this.router.navigate(['/user',currentUser.id,'edit']);
      }
      else if (this.redirectUrl) {
        this.router.navigateByUrl(this.redirectUrl);
      }
      else {
        this.router.navigateByUrl('/');
      }
    });
  }

  getFilterDate(){
        let d=new Date();
        let e=new Date(d.getFullYear(),d.getMonth()-10,d.getDate(),0,0,0,0);
        return e.toISOString();  
  }     
}
 

